
import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import { areaApi } from "../../../../API/areaApi/areaApi";
import { ConvertEnglish } from "../../../../components/ConterEnglsih";
import LoadingButton from "../../../../components/LoadingButton";
import { GStore } from "../../../../context/Context";

const AddAreaModal = ({handleAddArea,register,handleSubmit, loading}) => {
    const {english} = useContext(GStore);
  return (
    <div>
      {/* Put this part before </body> tag */}
      <input type="checkbox" id="add-area-modal" className="modal-toggle" />
      <label htmlFor="add-area-modal" className="modal cursor-pointer">
        <label className="modal-box relative" htmlFor="">
          <h3 className="text-lg font-bold">
          <ConvertEnglish english={"ADD A NEW AREA"} bangla={"নতুন এরিয়া সংযোগ করুন"} />
          </h3>
          <div className="my-5">
          <form onSubmit={handleSubmit(handleAddArea)}>
          <input type="text" {...register("area")} placeholder={english ? "WRITE A NEW AREA" : "নতুন এরিয়া লেখুন"} className="input input-bordered w-full " required/>
         <div className="mt-5 flex justify-center ">
         {
          loading ?<LoadingButton>সংযোগ করুন</LoadingButton> : <button type="submit" className="btn btn-outline w-full"><ConvertEnglish english={"ADD AREA"} bangla={"সংযোগ করুন"} /></button>
         }
         
         </div>
          </form>
          </div>
        </label>
      </label>
    </div>
  );
};

export default AddAreaModal;
